// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAGZdg8zeaIml43qWwhkPvSk_LgNERe4T8",
  authDomain: "clarity-aa6d1.firebaseapp.com",
  projectId: "clarity-aa6d1",
  storageBucket: "clarity-aa6d1.firebasestorage.app",
  messagingSenderId: "515546004923",
  appId: "1:515546004923:web:80631154d392fdb765589e",
  measurementId: "G-HYK9BSZ2X9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Domain configuration for multi-domain support
export const supportedDomains = [
  'clarity-aa6d1.web.app',
  'advicelink.org'
];

// Helper function to get current domain
export const getCurrentDomain = () => {
  return window.location.hostname;
};

// Helper function to check if current domain is supported
export const isSupportedDomain = () => {
  const currentDomain = getCurrentDomain();
  return supportedDomains.includes(currentDomain);
};

export default app;
